module.exports = __webpack_public_path__ + "img/p1-p1-biaoti.0ecd49de.png";